import { render, staticRenderFns } from "./NeighborhoodData.vue?vue&type=template&id=5c99556f&"
import script from "./NeighborhoodData.vue?vue&type=script&lang=js&"
export * from "./NeighborhoodData.vue?vue&type=script&lang=js&"
import style0 from "./NeighborhoodData.vue?vue&type=style&index=0&id=5c99556f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports